export function moneyFormat(v){
    if(typeof v == 'string'){
        return parseFloat(v).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
